import { IContact } from './contact';

export interface IStaffListResponse {
    data: {
        success: boolean;
        results: IContact[];
    }
}
